export default "__VITE_ASSET__dLmO0FL7__"